import { useState } from "react";
import { api } from "../../lib/api";
import { PageLoading, ErrorState } from "../../components/States";
import { fmtDateTime } from "../../lib/format";
import { useAdminData, SearchBox, Pager, TableCard, TH } from "./shared";

export default function AdminAudit() {
  const { data, error, page, setPage, filters, setFilters, reload } = useAdminData(api.adminAudit);
  const [q, setQ] = useState("");
  const rows = data?.items || [];

  return (
    <div data-testid="admin-audit-page">
      <div className="flex flex-wrap gap-3 mb-4">
        <SearchBox value={q} onChange={setQ} onSearch={() => setFilters((f) => ({ ...f, q }))} placeholder="Search action, actor or target…" testid="admin-audit-search" />
      </div>
      {error ? <ErrorState body={error} onRetry={reload} /> : !data ? <PageLoading label="Loading audit log…" /> : (
        <>
          <TableCard testid="admin-audit-table" empty={rows.length === 0 && "No audit events found."}
            head={<><TH>Action</TH><TH>Actor</TH><TH>Target</TH><TH>When</TH></>}>
            {rows.map((a) => (
              <tr key={a.audit_id} className="border-b border-[#18181B]" data-testid={`admin-audit-${a.audit_id}`}>
                <td className="p-4 font-semibold text-xs">{a.action}</td>
                <td className="p-4 text-xs text-zinc-400">{a.admin_email || a.actor_id || a.admin_id || "system"}</td>
                <td className="p-4 text-xs text-zinc-500">{a.target_type}/{a.target_id}</td>
                <td className="p-4 text-xs text-zinc-500">{fmtDateTime(a.created_at)}</td>
              </tr>
            ))}
          </TableCard>
          <Pager page={page} total={data.total} pageSize={data.page_size} onPage={setPage} testid="admin-audit-pager" />
        </>
      )}
    </div>
  );
}
